// extracted by mini-css-extract-plugin
export default {"wrapper":"OU-z","availablePromoMessagesLabel":"PU-z","promoMessageList":"QU-z","promoMessage":"RU-z","appliedPromoMessage":"SU-z","promoMessageAmount":"TU-z"};